import React from "react"

const terms = props => <div>terms</div>

export default terms



// WEBPACK FOOTER //
// ./src/scenes/Help/pages/terms.js